module.exports = __webpack_public_path__ + "static/img/CHEN_CHI-MING.jpg";